import React, { Component } from 'react'
import styled from 'styled-components'
import { getTheme } from '../../global/utils'

const Body = styled.div`
  padding: 0 ${getTheme('padding', 'horizontalPage')};
`

class PageBody extends Component {
  render() {
    return <Body className={this.props.className}>{this.props.children}</Body>
  }
}

export default PageBody



// WEBPACK FOOTER //
// ./src/components/shared/PageBody.js